import ServicesCarousel from "../../Components/ServicesCarousel/ServicesCarousel";

const Services = () => {
  return (
    <>
      <ServicesCarousel />
    </>
  );
};
export default Services;
